export const CATEGORY_ACTION = {
  GET_LIST_0: "GET_LIST_0_CATEGORY_ACTION",
  GET_LIST_1: "GET_LIST_1_CATEGORY_ACTION",
  GET_LIST_2: "GET_LIST_2_CATEGORY_ACTION",
};
